<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <div
          v-if="newsList.length > 0">
          <news-list :category="category" :newsList="newsList"></news-list>
          <b-pagination
            v-if="totalPage > 1"
            class="rounded-pagination news-list-pagination"
            size="sm"
            v-model="pageIndex"
            :per-page="pageSize"
            :total-rows="total"
            align="center"
            :prevText="ls_Prev"
            :nextText="ls_Next"
            :limit="limit"
            :hideGotoEndButtons="hideFirstLastBtn">
          </b-pagination>
        </div>
        <div v-else class="newses-container">
          <h4 class="about-title">
            {{ category.categoryName !== undefined ? category.categoryName : categoryName }}
          </h4>
          <div class="news-list">
            <h6 class="no-data"><i class="far fa-info-circle"></i> {{ ls_ThisPageHasNoData }}</h6>
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="news-sidebar">
          <div class="news-tag-list">
            <b-link v-for="(tag, index) in tagList" :key="index" @click="toCategory(tag)" class="news-tag-item">
              {{ tag.categoryName }}
            </b-link>
          </div>
          <div class="news-banner">
            <b-link :href="host + '/ads/show/15.html'" target="_blank" class="news-banner-link">
              <img :src="host + '/ads/show/15.png'" alt="xxx">
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import NewsList from "@/components/news/NewsList.vue";

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      totalPage: 1,
      newsList: [],
      tagList: [],
      limit: 4,
      hideFirstLastBtn: true,
      defaultCategory: {
        id: 0,
        categoryName: this.$store.state.languagePack.ls_AllNews,
        description: "",
        url: "/category"
      },
      category: {}
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_Prev() {
      return this.$store.state.languagePack.ls_Prev;
    },
    ls_Next() {
      return this.$store.state.languagePack.ls_Next;
    },

    ls_ThisPageHasNoData() {
      return this.$store.state.languagePack.ls_ThisPageHasNoData;
    },

    categoryName() {
      return this.$store.state.languagePack.ls_AllNews;
    }
  },

  created() {
    if (this.$route.query.page !== undefined) {
      this.pageIndex = Number(this.$route.query.page);
    }
    if (this.$route.query.tagId) {
      this.getArticleList(
        this.$route.query.page,
        this.pageSize,
        0,
        this.$route.query.tagId
      );
      this.category = this.defaultCategory;
    } else if (this.$route.query.keyWord) {
      this.getSearchNews();
      this.category = {
        id: 0,
        categoryName: this.$store.state.languagePack.ls_search,
        description: "",
        url: "/category"
      };
    } else {
      this.getArticleList(
        this.$route.query.page,
        this.pageSize,
        this.$route.query.cId
      );
      this.category = this.defaultCategory;
    }
    this.getcategorylist();
  },

  methods: {
    toCategory(tag) {
      this.category = tag;
      this.pageIndex = 1;
      this.getArticleList(1, 10, tag.id);
      this.$router.push({
        path: "article",
        query: {
          cId: tag.id,
          page: 1
        }
      });
    },

    getSearchNews() {
      this.$store.state.loading = true;
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("keyWord", this.$route.query.keyWord);
      this.$http
        .post(this.host + "/api/qazlatyn/getarticlelist", fd)
        .then(result => {
          this.$store.state.loading = false;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.totalPage = result.body.data.totalPage;
              this.total = result.body.data.total;
              this.newsList = result.body.data.dataList;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    getArticleList(pageIndex, pageSize, categoryId, tagId) {
      this.$store.state.loading = true;
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("page", pageIndex);
      fd.append("pageSize", pageSize);
      fd.append("tagId", tagId);
      if (categoryId > 0) {
        fd.append("cId", categoryId);
      }
      this.$http
        .post(this.host + "/api/qazlatyn/getarticlelist", fd)
        .then(result => {
          this.$store.state.loading = false;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.totalPage = result.body.data.totalPage;
              this.total = result.body.data.total;
              this.newsList = result.body.data.dataList;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    getcategorylist() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getcategorylist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.tagList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, oldVal) {
      if (oldVal.params.ln !== newVal.params.ln) {
        this.getcategorylist();
        if (this.$route.query.tagId !== undefined) {
          this.getArticleList(this.pageIndex, this.pageSize, 0, this.$route.query.tagId);
        } else if (this.category.id !== 0 && this.category.id !== undefined) {
          this.getArticleList(this.pageIndex, this.pageSize, this.category.id, 0);
        } else {
          this.getArticleList(this.pageIndex, this.pageSize);
        }
      }

      if (
        newVal.query.cId === undefined &&
        newVal.query.page === undefined &&
        newVal.query.keyWord === undefined
      ) {
        this.getArticleList(1, this.pageSize, 0);
        this.category = this.defaultCategory;
      }

      if (newVal.query.keyWord) {
        this.getSearchNews();
      }
    },
    pageIndex: function(val, oldVal) {
      if (val !== oldVal) {
        if (this.$route.query.tagId !== undefined) {
          this.getArticleList(this.pageIndex, this.pageSize, 0, this.$route.query.tagId);
          this.$router.push({
            path: "article",
            query: {
              tagId: this.$route.query.tagId,
              page: this.pageIndex
            }
          });
        } else if (this.category.id > 0) {
          this.getArticleList(this.pageIndex, this.pageSize, this.category.id, 0);
          this.$router.push({
            path: "article",
            query: {
              cId: this.category.id,
              page: this.pageIndex
            }
          });
        } else {
          this.getArticleList(this.pageIndex, this.pageSize);
          this.$router.push({
            path: "article",
            query: { page: this.pageIndex }
          });
        }
      }
    }
  },

  components: {
    "news-list": NewsList
  },

  metaInfo() {
    return {
      title: this.category.categoryName
    };
  }
};
</script>

<style lang="scss" scoped>
.news-sidebar {
  padding: 1rem;
  background-color: #ffffff;
  margin-top: 48px;
  border: 1px solid #dddfe2;

  .news-tag-list {
    margin-bottom: 18px;

    .news-tag-item {
      position: relative;
      display: inline-block;
      background-color: #ffffff;
      border: 1px solid #00849655;
      padding: 0.125rem 0.5rem;
      color: #585858;
      margin-right: 8px;
      margin-bottom: 12px;
      z-index: 2;

      &::after {
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12px 12px 0px 0;
        position: absolute;
        bottom: 0;
        right: 0;
        border-color: transparent #008496 transparent transparent;
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        text-decoration: none;

        &::after {
          content: "";
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 16px 16px 0px 0;
          position: absolute;
          bottom: 0;
          right: 0;
          border-color: transparent #008496 transparent transparent;
        }
      }
    }
  }

  .news-banner {

    .news-banner-link {
      img {
        width: 100%;
      }
    }
  }
}

/* RTL */
.rtl-layout .news-sidebar {

  .news-tag-list {
    direction: rtl;
    text-align: right;

    .news-tag-item {
      margin-right: 0;
      margin-left: 8px;

      &::after {
        border-width: 0 12px 12px 0;
        left: 0;
        border-color: transparent transparent #008496 transparent;
      }

      &:hover {

        &::after {
          border-width: 0 16px 16px 0;
          left: 0;
          border-color: transparent transparent #008496 transparent;
        }
      }
    }
  }
}
</style>

<style>
.news-list-pagination {
  margin-top: 4px;
}
.rounded-pagination > .page-item > .page-link,
.rounded-pagination > .page-item > .page-link {
  border-radius: 0.25rem !important;
  margin: 1rem 0.25rem;
}
.rounded-pagination > .page-item:first-child > .page-link,
.rounded-pagination > .page-item:last-child > .page-link,
.rounded-pagination > .page-item:first-child > .page-link:focus,
.rounded-pagination > .page-item:last-child > .page-link:focus {
  background-color: transparent;
  border: 0;
  border-radius: 0 !important;
  box-shadow: none;
}
</style>
